import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ArrowsDownUp, FunnelSimple, X } from '@phosphor-icons/react'

import { Button, ButtonSelect } from '@reveni-io/reveni-ui'

import QueryFilter from '@/common/components/QueryFilter/QueryFilter'
import { showClearFiltersButton } from '@/common/components/SelectedFilters/helpers'
import SelectedFilters from '@/common/components/SelectedFilters/SelectedFilters'

import { filterNames } from '../constants'
import FiltersModal from './FiltersModal/FiltersModal'
import { filterResetValues } from './constants'
import * as Styles from './styles'

const Filters = ({
  filters,
  onChangeFilter,
  query,
  toggleShowFiltersModal,
  showFiltersModal,
  onApplyFilters,
  onClearFilters,
  orderBy,
}) => {
  const { t } = useTranslation()

  const [selectedFilter, setSelectedFilter] = useState(null)

  const handleDeleteFilter = filterName => {
    const filterDefaultValues = filterResetValues[filterName] || [{ filter: filterName, value: null }]

    filterDefaultValues.forEach(({ filter, value }) => {
      onChangeFilter(filter, value, true)
    })
  }

  const handleClearFilters = () => {
    onChangeFilter(filterNames.status, [], false)
    onChangeFilter(filterNames.type, null, false)
    onChangeFilter(filterNames.invoiceDateStart, null, false)
    onChangeFilter(filterNames.invoiceDateEnd, null, false)
    onChangeFilter(filterNames.collectedDateStart, null, false)
    onChangeFilter(filterNames.collectedDateEnd, null, false)
    onClearFilters()
  }

  const onClickInFilterChip = filterName => {
    setSelectedFilter(filterName)
    toggleShowFiltersModal(true)
  }

  const handleOpenAddFilterModal = () => {
    toggleShowFiltersModal(true)
  }

  const onCloseFiltersModal = () => {
    setSelectedFilter(null)
    toggleShowFiltersModal(false)
  }

  return (
    <Styles.MainContainer>
      <Styles.HeaderContainer>
        <QueryFilter
          placeholder={t('Núm. de factura, o núm. de pedido')}
          defaultValue={query}
          onChange={query => onChangeFilter(filterNames.query, query)}
          onChangeValue={query => onChangeFilter(filterNames.query, query, false)}
        />
        <div>
          <div>
            <ButtonSelect
              Icon={ArrowsDownUp}
              value={orderBy}
              buttonSize="s"
              buttonVariant="text"
              handleChange={value => onChangeFilter(filterNames.orderBy, value)}
              menuItems={[
                { value: '-created_at', label: t('Fecha factura') },
                { value: '-collected_at', label: t('Fecha pago') },
                { value: 'pending_first', label: t('Estado pago') },
              ]}
            />
          </div>
          <Button size="s" variant="text" onClick={handleOpenAddFilterModal}>
            <FunnelSimple size={24} weight="light" />
            {t('Añadir filtro')}
          </Button>
          {showClearFiltersButton(filters) && (
            <Button size="s" variant="text" onClick={handleClearFilters}>
              <X size={24} weight="light" />
              {t('Limpiar filtros')}
            </Button>
          )}
        </div>
      </Styles.HeaderContainer>
      <SelectedFilters filters={filters} onDeleteFilter={handleDeleteFilter} onClickFilter={onClickInFilterChip} />
      <FiltersModal
        show={showFiltersModal}
        onClose={onCloseFiltersModal}
        filters={filters}
        onChangeFilter={onChangeFilter}
        onApplyFilters={onApplyFilters}
        preselectedFilterType={selectedFilter}
      />
    </Styles.MainContainer>
  )
}

export default Filters
